import { render, staticRenderFns } from "./AssetRow.vue?vue&type=template&id=4dead2b5&"
import script from "./AssetRow.vue?vue&type=script&lang=js&"
export * from "./AssetRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports